@if (viewReady) {
  <div
    [class]="sets_tabs ? 'sets-tabs-header' : 'tabs-header scroll-section'"
    [ngClass]="match_details ? 'match-tabs' : ''"
    [ngStyle]="sticky_width.length ? {width: sticky_width} : {}"
    >
    @for (item of tabItems$ | async; track item) {
      <div class="tab-label" (click)="selectTab(item)" [class.active]="activeTab === item">
        @if (item.labelComponent) {
          <ng-container [ngTemplateOutlet]="item.labelComponent.labelContent"></ng-container>
        }
        @if (!item.labelComponent) {
          {{ item.label }}
        }
      </div>
    }
  </div>
  <div class="tabs-content"
    [style]="match_details ? '' : 'overflow: hidden'"
    [class]="sets_tabs ? 'sets-tabs-content' : ''"
    >
    @if (activeTab && activeTab.bodyComponent) {
      <ng-container *ngTemplateOutlet="activeTab.bodyComponent.bodyContent"> </ng-container>
    }
  </div>
}
